import React from "react";
import { MapPin, Phone, Envelope } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SocialMedia from "../SocialMedia/SocialMedia";

const Contact = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="flex flex-col ">
      <Link className="hover:underline block" to="/contact-us">
        <p className="text-white mb-3 text-lg uppercase">{t("nav_contact")}</p>
      </Link>
      <div className="flex flex-col gap-y-3">
        <div className="flex items-scenter gap-x-2">
          <span className="bg-secondary p-1 text-lg rounded-full flex h-max text-black">
            <MapPin />
          </span>
          <p className="text-white">{t("Address")}</p>
        </div>
        <div className="flex items-center gap-x-2">
          <span className="bg-secondary p-1 text-lg text-black rounded-full">
            <Phone />
          </span>
          <a
            href={`tel:${
              i18n.language === "ar" ? "+966598670797" : "+966598670797"
            }`}
            dir="ltr"
            className="text-white hover:underline"
          >
            <p dir="ltr" className="text-lg">
              {i18n.language === "ar" ? "+966 5986 70797" : "+966 5986 70797"}
            </p>
          </a>
        </div>
        <div className="flex items-center gap-x-2">
          <span className="bg-secondary p-1 text-lg text-black rounded-full">
            <Envelope />
          </span>
          <a
            href="mailto:solutions@iasco.sa"
            className="text-white hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            solutions@iasco.sa
          </a>
        </div>
      </div>
      <SocialMedia />
    </div>
  );
};

export default Contact;
